export const loginMessage = 'Log in to PublishKit'
export const apiUrl = process.env.REACT_APP_BACKEND_API
export const loginType = 'email'
export const PROJECT_NAME = 'publish-kit-admin'

export const loginOperationId = (type) => {
  let operationId = 'createSessionByEmail'

  if (type === 'wallet') {
    operationId = 'createSessionByWallet'
  }

  if (type === '2fa') {
    operationId = 'createSessionByAttemptToken'
  }

  return operationId
}
